export default "__VITE_ASSET__BhlPihp6__"